/**
 * Pure admin-access predicates over the server's GET /capabilities answer
 * (admin.functions). Kept free of store/auth imports so pages and tests can
 * use them without loading the guard's boot machinery.
 */

import type { AdminFunction, AdminFunctionKey, ServerCapabilities } from '../../store/api/capabilitiesApi';

/** The caller's admin functions as the server reported them; [] when unknown. */
export function adminFunctionsFrom(caps: ServerCapabilities | undefined): AdminFunction[] {
  return caps?.admin?.functions ?? [];
}

/** Whether the server reported admin access: to the area (no fn) or to one function. */
export function adminAccessAllows(caps: ServerCapabilities | undefined, fn?: AdminFunctionKey): boolean {
  const functions = adminFunctionsFrom(caps);
  return fn ? functions.some((f) => f.key === fn) : functions.length > 0;
}
